import { render, staticRenderFns } from "./UploadResultApplyDiscount.vue?vue&type=template&id=37b73839"
import script from "./UploadResultApplyDiscount.vue?vue&type=script&lang=js"
export * from "./UploadResultApplyDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports